import {
  BILLING_MASTER_ITEMS_LOADED, BILLING_OPERATORS_LOADED,
  BILLING_OPERATOR_ITEMS_LOADED, BILLING_REVIEW_ITEMS_LOADED,
  BILLING_ACTIVITY_LOGS_LOADED,
} from '../actionTypes/billing';

const initialState = {
  masterItems: { data: [], total: 0, page: 1, limit: 50 },
  operators: [],
  operatorItems: [],
  reviewItems: { data: [], total: 0, page: 1, limit: 10 },
  activityLogs: { data: [], nextCursor: null },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BILLING_MASTER_ITEMS_LOADED:
      return { ...state, masterItems: action.payload };
    case BILLING_OPERATORS_LOADED:
      return { ...state, operators: action.payload };
    case BILLING_OPERATOR_ITEMS_LOADED:
      return { ...state, operatorItems: action.payload };
    case BILLING_REVIEW_ITEMS_LOADED:
      return { ...state, reviewItems: action.payload };
    case BILLING_ACTIVITY_LOGS_LOADED:
      return { ...state, activityLogs: action.payload };
    default:
      return state;
  }
};